<template>
  <div>
    <HeaderProductResale
      :title="`Adicionar Produtos > ${$route.query.product}`"
      text="Selecione a quantidade que você possui de cada variação do produto."
      :haveAction="false"
      :haveBack="true"
      actionTitle=""
    />

    <v-container
      style="max-width: unset; padding-bottom: 100px !important"
      class="pa-6 pt-2 mb-4"
    >
      <v-card
        transition="scale-transition"
        v-if="true"
        class="d-column mt-0 mb-6 py-2"
        elevation="0"
        color="#FFFFFF"
        style="border-radius: 6px"
      >
        <v-row class="py-3 px-6 ma-0" align="center">
          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="4"
            md="4"
            sm="6"
          >
            <v-text-field
              outlined
              class="px-0"
              style="
                border: 1px solid #979797;
                border-radius: 7.5px;
                width: 100%;
              "
              color="black"
              background-color="#F5F5F5"
              hide-details
              placeholder="SKU"
              v-model="filter.product"
              attach
              v-on:keyup="getProduct"
              :loading="loading"
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26"
                  >mdi-magnify</v-icon
                >
              </template>
            </v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-text-field
              outlined
              class="px-0"
              style="border-radius: 7.5px; width: 100%"
              append-icon="mdi-chevron-down"
              color="black"
              hide-details
              placeholder="Cor"
              v-model="filter.color"
              attach
              v-on:keyup="getProduct"
              :loading="loading"
            >
            </v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-btn
              block
              outlined
              height="56"
              style="border-radius: 7.5px"
              @click="reset"
              >Limpar filtros
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card
          v-if="resaleId && resale && resale.nameFantasy"
          transition="scale-transition"
          class="d-column mt-0 mb-6 py-2"
          elevation="0"
          color="#FFFFFF"
          style="border-radius: 6px"
      >
        <v-row class="py-1 px-6 ma-0" cols="12">
          <v-col cols="12">
            <h3>Cadastrar produtos para a revenda: <strong>{{resale.nameFantasy}}</strong></h3>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="pa-4" elevation="0">
        <div class="variation-header">Atributos</div>

        <v-row class="ma-0" v-for="(sku, i) in skus" :key="i" align="end">
          <v-col
            class="d-flex"
            v-for="(attr, idx) in sku.attributes"
            :key="idx"
          >
            <div v-if="attr.attribute.type === 'Cor'" class="mr-4">
              <div :style="switchStyle(attr.hex)" />
            </div>

            <div>
              <span class="variation-name">
                {{ attr.attribute.name }}
              </span>
              <br />
              {{ attr.name }}
            </div>
          </v-col>

          <v-col>
            <span class="variation-name"> Preço de venda </span>
            <br />
            <span class="value-column">
              R$ {{ sku.differentValue.toLocaleString() }}
            </span>
          </v-col>

          <v-col>
            <span class="variation-name"> SKU </span>
            <br />
            {{ sku.sku }}
          </v-col>

          <v-col class="d-flex justify-center align-center">
            <v-btn
              outlined
              class="history-button"
              icon
              width="35"
              height="35"
              @click="openHistory(sku)"
            >
              <v-icon>mdi-progress-clock</v-icon>
            </v-btn>
          </v-col>

          <v-col class="d-flex flex-column align-center">
            <div class="d-flex align-center flex-row justify-space-between flex-nowrap px-1" style="min-width: 300px">
              <span><strong>Preço mínimo: </strong>{{
                sku.minimumPrice.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                })
                }}
              </span>
              <div class="text-center">
                <strong>Seu preço</strong>
                <div class="mr-3 ml-1" style="border: 1px solid #979797; border-radius: 7.5px;">
                  <vuetify-money
                      :id="sku.id"
                      color="black"
                      v-bind:outlined="outlined"
                       placeholder="0.00"
                      required
                      :rules="[rules.required]"
                      hide-details
                      dense
                      v-model="sku.price"
                      v-bind:options="options"
                  ></vuetify-money>
                </div>
              </div>
              <span><strong>Preço máximo: </strong>{{
                  sku.maximumPrice.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </span>
            </div>
          </v-col>

          <v-col class="d-flex flex-column align-center">
            <span class="variation-name mb-3"> Quantidade </span>
            <div class="d-flex px-1">
              <v-text-field
                type="number"
                v-mask="'######'"
                style="width: 100px !important"
                outlined
                dense
                hide-details
                :key="quantityKey"
                v-model="sku.quantity"
              >
              </v-text-field>
            </div>
          </v-col>

          <!--<v-col class="d-flex flex-column align-center">
            <span class="variation-name mb-3">Estoque mínimo</span>
            <div class="d-flex px-1">
              <v-text-field
                type="number"
                v-mask="'######'"
                style="width: 80px !important"
                outlined
                dense
                hide-details
                :key="quantityKey"
                v-model="sku.minimumStock"
              >
              </v-text-field>
            </div>
          </v-col>-->
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <v-footer fixed padless class="main-footer">
      <v-row class="ma-0" justify="end">
        <v-col cols="12" sm="6" md="3" lg="3">
          <v-btn
            height="47"
            block
            class="add-button"
            elevation="0"
            @click="add"
          >
            adicionar selecionados
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>

    <v-dialog v-model="dialog" max-width="750">
      <HistoryModal :logs="currentLogs" :key="dialogKey" />
    </v-dialog>
  </div>
</template>

<style scoped>
.history-button {
  border: 2px solid #2d3038;
  box-sizing: border-box;
  border-radius: 4px;
  color: #000000;
  transition: 0.3s;
}

.history-button:hover {
  color: #fff !important;
  background: #000000 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.variation-header {
  display: flex;
  align-items: center;

  padding-left: 20px;

  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;

  background: #f5f5f5;
  border-radius: 4px;
  width: 100%;
  height: 70px;
}

.variation-name {
  font-weight: bold;
  font-size: 15px;
  line-height: 0px;
  letter-spacing: 0.15px;
  color: #979797;
}

.value-column {
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #9c9c9c;
}

.main-footer {
  background: #ffffff !important;
  box-shadow: 0px -3px 20px rgba(45, 48, 56, 0.1) !important;
  border-radius: 6px !important;
  position: fixed;
}

.add-button {
  background: #bc0000 !important;
  border-radius: 10px;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;

  transition: 0.3s;
}

.add-button:hover {
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import HeaderProductResale from "./components/HeaderProductResale.vue";
import HistoryModal from "./components/HistoryModal.vue";

export default {
  components: {
    HeaderProductResale,
    HistoryModal,
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    const { resaleId } = this.$route.query
    this.resaleId = resaleId ? resaleId : null;
    if(this.resaleId){
      await this.getResale()
    }
    await this.getProduct();
    this.productStatus = this.$route.query.status;
    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  data: () => ({
    outlined: true,
    options: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2,
      max: 10
    },
    productStatus: null,
    resaleId: null,
    resale: null,
    skus: [],
    originalSkus: [],
    resaleSkus: [],
    product: {},
    user: {},
    env_url: "",
    loading: false,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 15,
      ProductSKU: null,
      ProductCategory: null,
      ProductAtribute: null,
      Cores: null,
      Price: null,
    },
    currentLogs: [],
    dialog: false,
    dialogKey: false,
    oldSkuValue: 0,
    quantityKey: false,
    rules: {
      nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
      postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
    },
  }),

  methods: {
    insert(v) {
      if (this.productStatus != 0) {
        v.quantity = Number(v.quantity) + 1;
        this.quantityKey = !this.quantityKey;
      } else {
        this.$toast.error("Não foi possivel adicionar, produto inativado!");
      }
    },

    remove(v) {
      if (v.quantity > 0) {
        v.quantity = Number(v.quantity) - 1;
        this.quantityKey = !this.quantityKey;
      }
    },

    openHistory(sku) {
      sku.resaleSkus.forEach((resaleSkus) => {
        resaleSkus.logs.forEach((logs) => {
          this.currentLogs.push(logs);
        });
      });
      this.currentLogs.sort(
        (a, b) =>
          new Date(b.changeDate).getTime() - new Date(a.changeDate).getTime()
      );
      this.dialogKey = !this.dialogKey;
      this.dialog = true;
    },

    add() {
      this.loading = true;

      let addedSkus = this.skus
        .filter((x) => x.quantity != null)
        .map((x) => ({
          productSkuId: x.id,
          quantity: x.quantity,
          minimumStock: 0,
          price: x.price,
          doneByAdminOrMasterUser: this.resaleId !== null,
          resaleId: this.resaleId ? this.resaleId : this.user.id,
        }));

      if (addedSkus.length > 0) {
         if(!!this.skus.find(x => (!x.price || x.price <= 0) || x.price < x.minimumPrice || x.price > x.maximumPrice )){
          this.$toast.error("O seu preço de todos os produtos tem que estar entre o preço mínimo e máximo");
          return;
        }
        this.apiService
          .post("resaleproductsku/addlist", addedSkus)
          .then(async () => {
            this.$toast.success("SKUs adicionados");
            //this.$router.push("product-select");
            await this.$router.go(-1);
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$toast.error("Adicione a quantidade a pelo menos um SKU");
      }

      this.loading = false;
    },

    switchStyle(color, menu) {
      return {
        border: "2px dashed #DADADA",
        boxSizing: "border-box",
        backgroundColor: color,
        cursor: "pointer",
        height: "52px",
        width: "56px",
        margin: "0 auto 0 auto",
        borderRadius: menu ? "50%" : "10px",
        transition: "border-radius 200ms ease-in-out",
      };
    },

    action() {},

    async getResale() {
      this.apiService.get(`resale/get-one?id=${this.resaleId}`).then((response) => {
        this.resale = response;
      });
    },

    async getProduct() {
      try {
        this.loading = true;
        await this.apiService
            .post(`productsku/getbyproduct`, {
              productId: this.$route.query.id,
              name: this.filter.product,
              color: this.filter.color,
              userId: this.resaleId ? this.resaleId : this.user.id,
            })
            .then((response) => {
              response.content.forEach((item) => {
                const {price} = response && response.content2 && response.content2.length > 0 && response.content2.find(x => x.productSkuId == item.id)
                    ? response.content2.find(x => x.productSkuId == item.id)
                    : {};
                item.price = price ? price : item.differentValue;
              })
              this.skus = response.content.filter((x) => !x.delete_at);
              this.originalSkus = response.content.filter(
                  (x) => x.isActive === true
              );
              this.resaleSkus = response.content2;

              this.colorToFirst();
              this.intersectArrays();
              this.loading = false;
            })
            .catch((e) => {
              console.log(e)
              this.loading = false;
            });
      } catch (e) {
        console.log(e)
      }
    },

    intersectArrays() {
      this.resaleSkus.forEach((sku) => {
        let finded = this.skus.find((x) => x.id == sku.productSkuId);

        if (finded != null) {
          finded.quantity = sku.quantity;
          finded.minimumStock = sku.minimumStock;
        }
      });
    },

    colorToFirst() {
      this.skus.map((sku) => {
        let findColor = [];

        sku.quantity = 0;

        findColor = sku.attributes.filter((x) => x.attribute.type === "Cor");

        if (findColor.length > 0) {
          findColor.map((color) => {
            let idx = sku.attributes.findIndex((y) => y == color);
            sku.attributes.splice(0, 0, sku.attributes.splice(idx, 1)[0]);
          });
        }
      });
    },

    reset() {
      this.filter = {};
      this.getProduct();
    },
  },
};
</script>
